import {
  BOOKING_EQUIPEMENTS,
  BOOKING_ROOMS,
  BOOKING_USERS,
  BOOKING_CURRENT_SELECTION,
  CHANGE_CURRENT_MONTH
} from './bookingActions';

const initialState = {
  equipments: [],
  rooms: [],
  users: [],
  currentSelection: {
    equipments: [], // [{id: id,date: day}]
    rooms: [],
    users: []
  },
  currentMonth: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case BOOKING_EQUIPEMENTS:
      return { ...state, equipments: action.bookingEquipments };
    case BOOKING_ROOMS:
      return { ...state, rooms: action.bookingRooms };
    case BOOKING_USERS:
      return { ...state, users: action.bookingUsers };
    case BOOKING_CURRENT_SELECTION:
      return { ...state, currentSelection: action.selection };
    case CHANGE_CURRENT_MONTH:
      return { ...state, currentMonth: action.currentMonth };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/booking/reducer.js